import { css, cx } from 'emotion'
import { Classes } from '@blueprintjs/core'
import { css as css2 } from '@emotion/core'

// TODO 이상한 점: 여기서 (import { Classes } from '@blueprintjs/core) 를 제거하면 앱 전체가 이상해지고(이건 그냥 파일이고 blueprint에대한 improt는 온갖 곳에서 이뤄지는데도 불구하고)
// TODO 그리고 이 파일을 classes.js에서 import 했을 때 다른 css들의 우선순위가 꼬여서 이상해졌었음(근데 storybook에서는 또 그게 괜찮고 npm start에서만 이상해졌었음)

export const thickScrollbar = css`
::-webkit-scrollbar {
width: 20px;
height: 20px;
}
 ::-webkit-scrollbar-thumb {
     background-color: rgba(79, 79, 79, 0.4);
}
`

export const hasScrollbarIfHover = css`
scrollbar-color: rgba(0,0,0,0) rgba(0,0,0,0);
scrollbar-width: thin;
&:hover {
scrollbar-color: rgba(79, 79, 79, 0.2) rgba(0, 0, 0,, 0);
}

::-webkit-scrollbar {
width: 10px;
} 
  
::-webkit-scrollbar-thumb {
     background-color: transparent;
}
    &:hover {
 ::-webkit-scrollbar-thumb {
     background-color: rgba(79, 79, 79, 0.2);
}
}`

export const hasScrollbarIfHover2 = css2`
scrollbar-color: rgba(0,0,0,0) rgba(0,0,0,0);
scrollbar-width: thin;
&:hover {
scrollbar-color: rgba(79, 79, 79, 0.2) rgba(0, 0, 0,, 0);
}

::-webkit-scrollbar {
width: 10px;
} 
  
::-webkit-scrollbar-thumb {
     background-color: transparent;
}
    &:hover {
 ::-webkit-scrollbar-thumb {
     background-color: rgba(79, 79, 79, 0.2);
}
}`

export const hasScrollbarAlways = css`
scrollbar-width: thin;
scrollbar-color: rgba(79, 79, 79, 0.2) rgba(0, 0, 0, 0);

::-webkit-scrollbar {
width: 10px;
}
 ::-webkit-scrollbar-thumb {
     scrollbar-width: thin;
     background-color: rgba(79, 79, 79, 0.2);
}
`
export const hotKeyClass = cx(Classes.CODE, css`opacity: 0.8; font-size: 0.8em;`)
// export const hotKeyClass = css`opacity: 0.8; font-size: 0.8em;`
